import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// A slim, fixed banner that appears whenever the guest's phone loses its connection while
// browsing the menu. It reassures them that their cart is safe (we persist it to localStorage)
// and quietly disappears the moment they're back online. Pure browser events — no polling.
const OfflineBanner = () => {
    const { t } = useTranslation();
    const [offline, setOffline] = useState(
        typeof navigator !== 'undefined' && navigator.onLine === false
    );

    useEffect(() => {
        const goOffline = () => setOffline(true);
        const goOnline = () => setOffline(false);
        window.addEventListener('offline', goOffline);
        window.addEventListener('online', goOnline);
        return () => {
            window.removeEventListener('offline', goOffline);
            window.removeEventListener('online', goOnline);
        };
    }, []);

    if (!offline) return null;

    return (
        <div role="status" aria-live="polite" style={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
            background: '#b91c1c', color: '#fff',
            font: '600 0.85rem/1.3 system-ui, sans-serif',
            textAlign: 'center', padding: '0.55rem 1rem',
            boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
        }}>
            {t('errors.offline')}
        </div>
    );
};

export default OfflineBanner;
